import React, { memo } from "react";

import useUnsupportedBrowserBanner from "./hooks/useUnsupportedBrowserBanner";

const BANNER_STYLE: React.CSSProperties = {
  backgroundColor: "#FF0000",
  color: "#FFFFFF",
  padding: "12px 32px 12px 20px",
  textAlign: "center",
  position: "relative",
  zIndex: 9999,
  fontWeight: 600,
};

const CLOSE_BUTTON_STYLE: React.CSSProperties = {
  position: "absolute",
  right: "12px",
  top: "50%",
  transform: "translateY(-60%)",
  background: "none",
  border: "none",
  fontSize: "24px",
  fontWeight: 700,
  cursor: "pointer",
  color: "#FFFFFF",
};

type BannerCloseButtonProps = {
  onDismiss: () => void;
};

const CloseButton = ({ onDismiss }: BannerCloseButtonProps) => (
  <button data-testid="UnsupportedBrowserBanner-CloseButton" style={CLOSE_BUTTON_STYLE} onClick={onDismiss} aria-label="Dismiss banner">
    ×
  </button>
);

const UnsupportedBrowserBanner = () => {
  const { stateIsBannerVisible, dismissBanner } = useUnsupportedBrowserBanner();

  if (!stateIsBannerVisible) {
    return null;
  }

  return (
    <div data-testid="UnsupportedBrowserBanner" style={BANNER_STYLE} role="alert">
      Your browser is out of date. Some visual elements may not display correctly. Please update your browser for the best experience.
      <CloseButton onDismiss={dismissBanner} />
    </div>
  );
};

export default memo(UnsupportedBrowserBanner);
